import React, { useState } from 'react';
import {
    Form,
    Input,
    DatePicker,
    Button,
    Radio,
    Checkbox,
    Row,
    Col,
    Typography,
    Divider,
    Flex,
    Space,
    message
} from 'antd';
import { MailOutlined, PhoneOutlined, VideoCameraOutlined } from '@ant-design/icons';
import axiosInstance from '../../services/axiosInstance';
import { catchError } from '../../utils/errorHandler';
import { useMediaQuery } from 'react-responsive';
const { TextArea } = Input;
const { Title } = Typography;

const RequestClientContact = ({ handlecloseModal }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [salesRepChecked, setSalesRepChecked] = useState(false);
    const [businessHeadChecked, setBusinessHeadChecked] = useState(false);
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });


    const onFinish = async (values) => {
        setLoading(true);
        try {
            const response = await axiosInstance.post('/task/v2/request-client-contact/', values);
            if (response.status == 201) {
                message.success(response?.data?.message)
                setLoading(false);
                handlecloseModal()
            }

        } catch (err) {
            await catchError(err)
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ paddingRight: "15px" }}>
            <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
            >
                <div style={{ width: "100%" }}>
                    <Title level={4} style={{ marginTop: "0px" }}>Employee Information</Title>
                    <Row gutter={16}>
                        <Col lg={12}>
                            <Form.Item
                                label="Employee Name"
                                name="employee_name"
                                style={{ fontWeight: "bold" }}
                                rules={[{ required: true, message: 'Please enter your name' }]}
                            >
                                <Input placeholder="Enter your full name" />
                            </Form.Item>
                        </Col>
                        <Col lg={12}>
                            <Form.Item
                                label="Department"
                                name="employee_department"
                                style={{ fontWeight: "bold" }}
                                rules={[{ required: true, message: 'Please enter your department' }]}
                            >
                                <Input placeholder="e.g., Sales, Marketing, Support" />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
                <Divider style={{ margin: '0px 0px 20px' }} />

                <div style={{ width: "100%" }}>
                    <Title level={4} style={{ marginTop: "0px" }}>Client Information</Title>
                    <Row gutter={16}>
                        <Col lg={12}>
                            <Form.Item
                                label="Client Name / Username"
                                name="client_username"
                                style={{ fontWeight: "bold" }}
                                rules={[{ required: true, message: 'Please enter client name' }]}
                            >
                                <Input style={{ width: "100%" }} placeholder="Enter client name or username" />
                            </Form.Item>
                        </Col>
                        <Col lg={12}>
                            <Form.Item
                                label="Sales Representative"
                                name="sales_representative"
                                style={{ fontWeight: "bold" }}
                                rules={[{ required: true, message: 'Please enter sales rep name' }]}
                            >
                                <Input placeholder="Enter sales rep name" />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
                <Divider style={{ margin: '0px 0px 20px' }} />

                <div style={{ width: "100%" }}>
                    <Title level={4} style={{ marginTop: "0px" }}>Contact Details</Title>

                    <Form.Item
                        label="Reason for Contact"
                        name="reason_for_contact"
                        style={{ fontWeight: "bold" }}
                        rules={[{ required: true, message: 'Please specify the reason' }]}
                    >
                        <TextArea rows={3} placeholder="Describe the reason of contacting this client" />
                    </Form.Item>

                    <Row gutter={16}>
                        <Col xs={24} lg={12}>
                            <Form.Item
                                name="urgency_level"
                                label={
                                    <span style={{
                                        fontWeight: '500',
                                        color: '#374151',
                                        fontSize: '14px'
                                    }}>
                                        Urgency Level <span style={{ color: '#ef4444' }}>*</span>
                                    </span>
                                }
                                rules={[{ required: true, message: 'Please select urgency level' }]}
                                style={{ marginBottom: '32px' }}
                            >
                                <Radio.Group>
                                    <Radio value="low">
                                        Low
                                    </Radio>
                                    <Radio value="medium">
                                        Medium
                                    </Radio>
                                    <Radio value="high">
                                        High
                                    </Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>



                        <Col xs={24} lg={12}>
                            <Form.Item
                                name="proposed_contact_method"
                                label={
                                    <span style={{
                                        fontWeight: '500',
                                        color: '#374151',
                                        fontSize: '14px'
                                    }}>
                                        Contact Methods <span style={{ color: '#ef4444' }}>*</span>
                                    </span>
                                }
                                rules={[{ required: true, message: 'Please select urgency level' }]}
                                style={{ marginBottom: '32px' }}
                            >
                                <Radio.Group>
                                    <Radio value="phone">
                                        {!isMobile && <PhoneOutlined style={{ marginRight: '8px', marginLeft: '8px' }} />}
                                        Phone
                                    </Radio>
                                    <Radio value="email">
                                        {!isMobile && <MailOutlined style={{ marginRight: '8px', marginLeft: '8px' }} />}
                                        Email
                                    </Radio>
                                    <Radio value="video">
                                        {!isMobile && <VideoCameraOutlined style={{ marginRight: '8px', marginLeft: '8px' }} />}
                                        Video
                                    </Radio>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
                <Divider style={{ margin: '0px 0px 20px' }} />


                <div style={{ width: "100%" }}>
                    <Title level={4} style={{ marginTop: "0px" }}>Message & Scheduling </Title>
                    <Row gutter={16}>
                        <Col lg={12}>
                            <Form.Item
                                label="Proposed Message / Talking Points"
                                name="proposed_message"
                                style={{ fontWeight: "bold" }}
                                rules={[{ required: true, message: 'Please enter your message' }]}
                            >
                                <TextArea rows={4} placeholder="Key points to discuss with the client" />
                            </Form.Item>
                        </Col>

                        <Col lg={12}>
                            <Form.Item
                                label="Preferred Contact Date & Time"
                                name="preferred_date_time"
                                style={{ fontWeight: "bold" }}
                                rules={[{ required: true, message: 'Please enter your preferred contact date and time' }]}
                            >
                                <DatePicker
                                    showTime
                                    style={{ width: '100%' }}
                                    format="YYYY-MM-DD HH:mm:ss"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
                <Divider style={{ margin: '0px 0px 20px' }} />

                <div style={{ width: "100%" }}>
                    <Title level={4} style={{ marginTop: "0px" }}>Pre-Approval Status</Title>

                    <Form.Item
                        name="approved_by_sales_rep"
                        valuePropName="checked"
                        initialValue={false}
                        style={{ marginBottom: 10 }}
                    >
                        <div style={{ padding: "15px", display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: "#F9FAFB", borderRadius: "10px" }}>
                            <div style={{ color: '#4a4a4a' }}>Sales Representative Approval</div>
                            <Space size={8} align="center">
                                <Checkbox
                                    checked={salesRepChecked}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setSalesRepChecked(checked);
                                        form.setFieldsValue({ approved_by_sales_rep: checked });
                                    }}
                                    disabled={businessHeadChecked}
                                />
                                <div style={{ fontWeight: 500 }}>Mark as Pre-Approved</div>
                            </Space>
                        </div>
                    </Form.Item>

                    <Form.Item
                        name="approved_by_business_head"
                        valuePropName="checked"
                        initialValue={false}
                    >
                        <div style={{ padding: "15px", display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: "#F9FAFB", borderRadius: "10px" }}>
                            <div style={{ color: '#4a4a4a' }}>Business Head Approval</div>
                            <Space size={8} align="center">
                                <Checkbox
                                    checked={businessHeadChecked}
                                    onChange={(e) => {
                                        const checked = e.target.checked;
                                        setBusinessHeadChecked(checked);
                                        form.setFieldsValue({ approved_by_business_head: checked });
                                    }}
                                    disabled={salesRepChecked}
                                />
                                <div style={{ fontWeight: 500 }}>Mark as Pre-Approved</div>
                            </Space>
                        </div>
                    </Form.Item>
                </div>

                <Divider style={{ margin: '0px 0px 20px' }} />

                <Flex style={{ width: "100%" }} justify="flex-end" align="flex-end">
                    <Button type="primary" htmlType="submit" loading={loading}>
                        Submit
                    </Button>
                </Flex>

            </Form >
        </div >
    );
};

export default RequestClientContact;
